import { useDispatch } from "react-redux";
import { setStatusChangeEventOption } from "../../actions";
import { ChoiceListComponent, TableComponent } from "../../components";

export const StatusChangeEventComponent = (props: any) => {
    const dispatch = useDispatch();
    const { optionsObject, optionsHeaderObject } = props;
    const setValue = (statusChangeBenefitCombinationID: number) => {
        props.setStatusChangeEventOption(statusChangeBenefitCombinationID);
        dispatch(setStatusChangeEventOption(statusChangeBenefitCombinationID));
    };
    
    const headerData: any = [
        optionsHeaderObject?.benefits && { headername: optionsHeaderObject?.benefits },
        optionsHeaderObject?.currentCoverage && { headername: optionsHeaderObject?.currentCoverage },
        optionsHeaderObject?.currentStatus && { headername: optionsHeaderObject?.currentStatus },
        optionsHeaderObject?.newStatus && { headername: optionsHeaderObject?.newStatus }
    ];

    const optionsDiv: any = [];
    const rowOptions: any = [];
    if (optionsObject?.statuChangeEventBenefits.length)
        optionsObject?.statuChangeEventBenefits.map((opt: any) => {
            const rowOptionData: any = [
                optionsHeaderObject?.benefits && {
                    type: "text",
                    display: opt?.benefitName || "",
                    colclassname: "text-start",
                    datatitle: optionsHeaderObject?.benefits
                },
                optionsHeaderObject?.currentCoverage && {
                    type: "text",
                    display: opt?.currentCoverage || "",
                    colclassname: "text-start",
                    datatitle: optionsHeaderObject?.currentCoverage
                },
                optionsHeaderObject?.currentStatus && {
                    type: "text",
                    display: opt?.currentStatus || "",
                    colclassname: "text-start",
                    datatitle: optionsHeaderObject?.currentStatus
                },
                optionsHeaderObject?.newStatus && {
                    type: "text",
                    display: opt?.newStatus || "",
                    colclassname: "text-start",
                    datatitle: optionsHeaderObject?.newStatus
                }
            ];

            rowOptions.push(rowOptionData);

        });

    const tblOptions = {
        className: "w-100",
        header: {
            headerData: headerData
        },
        body: {
            gridRowData: rowOptions
        }
    };

    //Benefit option
    const tid = "benefitCombinationName-" + optionsObject?.benefitCombinationName?.replace(/\s+/g, "-").toLowerCase() + "benefitCombinationID-" + optionsObject?.statusChangeBenefitCombinationID;
    const options = {
        name: optionsObject?.benefitCombinationName?.replace(/\s+/g, "-").toLowerCase() + "-" + optionsObject?.statusChangeBenefitCombinationID,
        selected: optionsObject?.isSelected ? true : false,
        className: `fw-bold`,
        ischecked: true,
        fgclass: "",
        isCallbackParam: true,
        disabled: false,
        isInvalid: false,
        handlechange: () => setValue(optionsObject?.statusChangeBenefitCombinationID),
        optionsinput: [
            {
                id: optionsObject?.isSelected ? "selectEnableCheckbox" + tid : "selectNoEnableCheckbox" + tid,
                text: optionsObject?.benefitCombinationName,
                value: optionsObject?.statusChangeBenefitCombinationID
            }
        ]
    };

    optionsDiv.push(
        <div
            key={optionsObject?.statusChangeBenefitCombinationID}
            className={"mb-3 benefit-option status-change-event-benefit-option"}>
            <div id={optionsObject.benefitCombinationName + optionsObject?.statusChangeBenefitCombinationID + "-option-div"}
                className={`header d-block ${optionsObject?.isSelected ? "card-header" : ""}`}>
                <div className="row">
                    <ChoiceListComponent choicelistdata={options} />
                </div>
            </div>
            <div className="col-xs-12 col-md-12 col-lg-12 status-change-event-benefit-option-body ml-benefitoptions">
                <TableComponent uniqueKey={optionsObject.benefitCombinationName + optionsObject.statusChangeBenefitCombinationID + "-option-table"} benefitName={optionsObject.benefitCombinationName} tableObject={tblOptions}></TableComponent>
            </div>
        </div>
    );

    return optionsObject ? (
        <>
            <div className="card-body">
                <div className={`ml-options mt-md-4 float-none clearfix`}>
                    {optionsDiv}
                </div>
            </div>
        </>
    ) : null;

};

export default StatusChangeEventComponent;